import { cn, Spinner } from "@jana-technology/platform-ui";

import type { LoadingSpinnerProps } from "./types";

export const LoadingSpinner = ({
  className,
  loading = false,
  label,
  children,
}: LoadingSpinnerProps) => {
  if (loading) {
    return <Spinner className={cn(className)} label={label} />;
  }

  return children;
};

export default LoadingSpinner;
